import React from 'react'
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { connect } from 'react-redux';


//CONNECT TO STORE
@connect((store) => {
    return { user: store.user, permissionStore: store.permission, siteMaster: store.siteMaster }
})

export default class TrustPilotAddBusiness extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            businessData: [],
            appData: {},
            isLoaded: false,
            currDomain: "",
            currDomainErr: ""
        };

        this.getApp = this.getApp.bind(this);
        this.getBusinessData = this.getBusinessData.bind(this);
        this.addDomain = this.addDomain.bind(this);
    }

    componentDidMount() {
        this.getApp();
    }

    getApp() {
        var self = this;
        axios.get("/application/36").then(_theApp => {
            self.setState({ appData: _theApp.data.Application }, self.getBusinessData)
        })
    }

    getBusinessData() {
        var self = this;
        axios.get("/application/account/app/36").then(_theResp => {
            var bizData = [];

            if (_theResp.data.Application.appSettings && _theResp.data.Application.appSettings.businessData) {
                bizData = _theResp.data.Application.appSettings.businessData;
            }

            self.setState({ appData: _theResp.data.Application, businessData: bizData, isLoaded: true })
        })
    }

    addDomain() {

        if (!this.state.currDomain || this.state.currDomain.length < 3 || this.state.currDomain.indexOf(".") < 0) {
            this.setState({ currDomainErr: "Invalid domain name" });
            return;
        }
        axios.post("/application/trustpilot/addbusiness", { domainName: this.state.currDomain }).then(_theResp => {
            this.setState({ currDomain: "", currDomainErr: "" }, this.getBusinessData);
        }).catch(exception => {
            this.setState({ currDomainErr: exception.data.error })
        })
    }

    render() {

        if (!this.state.isLoaded) return <div><LoadingIcons iconType="2" /></div>

        return <div>
            <Row>
                <Column xs={12} margin={0}>
                    <Paper>
                        <Row>
                            <Column xs={12}>
                                <h4 className="mar-b25">Trust Pilot is Connected!</h4>
                                <p><strong>Before we can get started, we need to know which of your Businesses you would like to sync from TrustPilot.</strong></p>
                                <p>Please enter the website address of the business or businesses you have added to TrustPilot...</p>
                            </Column>
                            <Column xs={12} margin={0}>
                                <div className="form-group mar-b0" >
                                    <label>Your website url, as registered on Trust Pilot</label>
                                    <Row>
                                        <Column xs="12" sm="10" md="11" lg="11">
                                            <TextInput placeholder="yourwebsite.com" value={this.state.currDomain} onChange={(event) => { this.setState({ currDomain: event.target.value }) }} error={this.state.currDomainErr} />
                                        </Column>
                                        <Column xs="12" sm="2" md="1" lg="1" className="text-right" margin={0}>
                                            <Button className="button-sml" text="Add" onClick={this.addDomain} />
                                        </Column>
                                    </Row>

                                </div>

                            </Column>
                            {this.state.businessData && this.state.businessData.length > 0 && <Column xs={12} margin={0}>
                                {this.state.businessData.map((bu, id) => {
                                    return <SquareChip value={bu.name} className="square-chip-secondary" />
                                })}
                            </Column>
                            }
                        </Row>
                    </Paper>
                </Column>

                {this.state.businessData && this.state.businessData.length > 0 &&
                    <Column xs={12} className="center-xs">
                        <Button text="Save and Continue" onClick={() => { this.props.history.push("/cp/company/integrations/apps/trustpilot") }} />
                    </Column>
                }
            </Row>

        </div >

    };


};


